import { LatLngBoundsLiteral } from 'leaflet';
import React from 'react';
import { Map as LeafletMap, MapProps, TileLayer } from 'react-leaflet';

const OSM_TILE_URL =
  process.env.REACT_APP_OSM_TILE_URL || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

// Bounding box covering the Netherlands (incl. Wadden islands and Zeeland), with some margin.
const NETHERLANDS_BOUNDS: LatLngBoundsLiteral = [
  [50.6, 2.9],
  [53.85, 7.4]
];

interface Props extends Omit<MapProps, 'maxBounds' | 'maxBoundsViscosity' | 'children'> {
  mapRef: any;
}

const NetherlandsBoundedMap: React.FC<Props> = ({ mapRef, ...mapProps }) => (
  <LeafletMap {...mapProps} ref={mapRef} maxBounds={NETHERLANDS_BOUNDS} maxBoundsViscosity={1.0}>
    <TileLayer
      url={OSM_TILE_URL}
      minZoom={7}
      maxZoom={20}
      maxNativeZoom={18}
      bounds={NETHERLANDS_BOUNDS}
    />
  </LeafletMap>
);

export default NetherlandsBoundedMap;
